import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { StorageService } from './storage.service';
import { ConfigService } from './config.service';

@Injectable()
export class AlertService {

    public alertsObserver = new Subject<string[]>();
    private alerts = [];
    private persistInLocalStorage: boolean;
    private hiddenAlerts;

    constructor(
        private storageService: StorageService,
        private configService: ConfigService
    ) {
        this.persistInLocalStorage = configService.get('alerts').persistInLocalStorage;
        if(this.persistInLocalStorage) {
            if(!storageService.get('hidden_alerts'))
                storageService.set('hidden_alerts', []);
            this.hiddenAlerts = storageService.get('hidden_alerts');
        } else {
            this.hiddenAlerts = [];
        }
    }

    hide(id: string, userId: string) {
        if(userId) {
            this.hiddenAlerts = this.readCookie('hide_alert_user_' + userId);
            this.hiddenAlerts = this.hiddenAlerts ? (this.hiddenAlerts.split(',').length > 0 ? this.hiddenAlerts.split(',') : this.hiddenAlerts) : null;
            if(!this.hiddenAlerts || !this.hiddenAlerts.length){
                document.cookie = 'hide_alert_user_' + userId + '=' +  id + ';path=/;';
            } else if (this.hiddenAlerts && !this.hiddenAlerts.some(el => el === id)) {
                this.hiddenAlerts.push(id);
                let alertsIds = this.hiddenAlerts.join(',');
                document.cookie = 'hide_alert_user_' + userId + '=' +  alertsIds + ';path=/;';
            }
        }

        // if(this.persistInLocalStorage)
            // this.storageService.set('hidden_alerts', this.hiddenAlerts);
        this.alertsObserver.next(this.alerts);
    }

    set(alerts: any[]) {
        this.alerts = alerts;
        this.alertsObserver.next(this.alerts)
    }

    getHiddenAlerts() {
        return this.hiddenAlerts;
    }

    readCookie(name) {
        let nameEQ = name + '=';
        let ca = document.cookie.split(';');
        for(let i=0;i < ca.length;i++) {
            let c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/alert.service.ts